export default "__VITE_ASSET__6410c035__"